import { METADATA } from './index';
import { Action } from '../action';
import { MetadataState } from '@shared/core';

export class MetadataHydrateAction implements Action {
	readonly type = METADATA.HYDRATE;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class MetadataHydrateFailureAction implements Action {
	readonly type = METADATA.HYDRATE_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class MetadataHydrateSuccessAction implements Action {
	readonly type = METADATA.HYDRATE_SUCCESS;
	constructor(
		public payload: MetadataState,
		public correlationId?: number
	) {}
}
